<template>

	<section class="section">
		<div class="container">
			<div class="columns is-multiline is-centered my-5">
				<article v-for="(addon, key) in data.products" :key="key" class="column is-half" :class="{ 'is-disabled': productAvailable[key] === false }">
					<h2 v-text="addon.label" class="title is-2 has-text-centered"></h2>

					<input
						type="checkbox"
						:value="key"
						:id="`addon-${key}`"
						v-model="selectedAddons[key]"
						@change="updateAddons()"
						class="is-hidden"
						tabindex="-1"
					/>
					<label :for="`addon-${key}`" class="addon-option" tabindex="1">
						<h3 v-text="addon.name" class="title is-3"></h3>

						<features product="addons" :selected-tier="key"></features>

						<footer class="has-text-right" v-if="!addon.requiresCustomQuote">
							<p v-text="formatPercent(addon.priceMultiplier)" class="is-size-1 has-text-navy has-text-weight-bold"></p>
							<p v-text="data.per" class="is-size-7"></p>
							<p v-if="addon.priceMinimum" v-text="`Minimum contract size ${formatMoney(addon.priceMinimum)}/mo`" class="is-size-7"></p>
						</footer>
					</label>
				</article>
			</div>
		</div>
	</section>

</template>

<script>

import Features from './Features.vue';

export default {
	name: 'addon-selector',

	data() {
		return {
			/* Currently selected addons */
			selectedAddons: {},
		};
	},

	computed: {
		data() {
			return this.$store.data[this.product] || {};
		},
	},

	methods: {
		/* Create keys for all existing addons, and set to false */
		initialiseAddons() {
			Object.keys(this.data.products).forEach(key => {
				this.$set(this.selectedAddons, key, false);
			});
		},

		/* Send selected tier to the store */
		updateAddons() {
			this.$set(this.$store.selection, 'addons', this.selectedAddons);
		},
	},

	created() {
		/* Initialise addon object from store */
		this.initialiseAddons();
		this.updateAddons();
	},

	watch: {
		/* When product availability changes */
		productAvailable(newAvailability) {
			/* If any products become unavailable, unselect them too */
			Object.keys(newAvailability).forEach((product) => {
				if (newAvailability[product] === false) {
					this.$set(this.selectedAddons, product, false);
				}
			});

			this.updateAddons();
		},
	},

	props: {
		/* Product name */
		/* [ compare, automation, addons, backup ] */
		product: {
			required: true,
		},

		/* Whether or not products are available to select */
		productAvailable: Object,
	},

	components: {
		features: Features,
	},
};

</script>

<style lang="scss" scoped>
@import '@gearset/web-core/styles/includes/variables';

article {
	transition: .2s opacity ease-in-out;
	display: flex;
	flex-direction: column;

	label {
		flex: 1;
	}

	&.is-disabled {
		opacity: .3;
		pointer-events: none;
	}
}

.addon-option {
	padding: 2rem;
	margin: 0;

	&::before,
	&::after {
		top: 1.75rem;
		left: 2rem;
		width: 2.25rem;
		height: 2.25rem;
		margin-top: 0;
	}

	&::before {
		border-radius: .25rem;
	}

	&::after {
		background: url('/images/pricing/tickbox.svg') no-repeat center center;
	}

	.title {
		margin-bottom: 1.75rem;
		padding-left: 3.5rem;
	}

	footer {
		padding-top: 1.5rem;
	}
}

</style>
